import { render, staticRenderFns } from "./SaleTrend.vue?vue&type=template&id=844a7952&"
import script from "./SaleTrend.vue?vue&type=script&lang=js&"
export * from "./SaleTrend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports